import Flatpickr from "react-flatpickr";
import { useField } from "formik";

const DatePickerField = ({ ...props }) => {
  const [field, meta, helpers] = useField(props.name);

  // Convert stored value (d-m-Y or d/m/Y) --> Date object
  const getDateValue = () => {
    if (!field.value) return null;

    // Case 1: dd/mm/yyyy
    if (field.value.includes("/")) {
      const [dd, mm, yyyy] = field.value.split("/");
      return new Date(`${yyyy}-${mm}-${dd}`);
    }

    // Case 2: dd-mm-yyyy
    if (field.value.includes("-")) {
      const [dd, mm, yyyy] = field.value.split("-");
      return new Date(`${yyyy}-${mm}-${dd}`);
    }

    return null;
  };

  return (
    <>
      <Flatpickr
        {...props}
        value={getDateValue()}
        className="form-control"
        options={{
          dateFormat: "d/m/Y", // show in UI like 01/11/2025
        }}
        onChange={(selectedDates) => {
          if (selectedDates[0]) {
            const d = selectedDates[0];
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();

            // store as dd-mm-yyyy
            helpers.setValue(`${day}-${month}-${year}`);
          }
        }}
      />

      {meta.touched && meta.error && (
        <div className="text-danger small">{meta.error}</div>
      )}
    </>
  );
};

export default DatePickerField;
